import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { DataService } from '@app/data';

@Component({
  selector: 'app-page-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.less']
})
export class PageHeaderComponent implements OnInit {

  @Input() page?: any;

  //public article?: any;

  constructor(
    private data: DataService
  ) { }

  ngOnInit(): void {

    //this.article = this.page;

    //this.data.setScreenSection(this.page);
  }

}
